module.exports = __webpack_public_path__ + "static/img/shanxirenming.4014527.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/shanxirenming.jpg
// module id = gesA
// module chunks = 36